(function() {
  'use strict';

  // 初始化所有 mega header 实例
  function initMegaHeader() {
    const headers = document.querySelectorAll('.mt-mega-header');
    
    headers.forEach(function(header) {
      // 移动端菜单切换
      const mobileToggle = header.querySelector('.mt-mega-header__mobile-toggle');
      const mobileMenu = header.querySelector('.mt-mega-header__mobile-menu');
      
      if (mobileToggle && mobileMenu) {
        mobileToggle.addEventListener('click', function() {
          const isExpanded = mobileToggle.getAttribute('aria-expanded') === 'true';
          mobileToggle.setAttribute('aria-expanded', !isExpanded);
          mobileMenu.classList.toggle('is-open');
        });
      }

      // 移动端下拉菜单切换
      const dropdownToggles = header.querySelectorAll('[data-mobile-menu-toggle]');
      
      dropdownToggles.forEach(function(toggle) {
        toggle.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          const menuItem = toggle.closest('.mt-mega-header__mobile-menu-item');
          if (!menuItem) return;

          const currentlyOpen = menuItem.classList.contains('is-open');
          const allMenuItems = header.querySelectorAll('.mt-mega-header__mobile-menu-item');

          allMenuItems.forEach(function(item) {
            if (item !== menuItem) {
              item.classList.remove('is-open');
              const itemToggle = item.querySelector('.mt-mega-header__mobile-dropdown-toggle');
              const blocks = item.querySelector('.mt-mega-header__mobile-blocks');
              if (itemToggle) itemToggle.setAttribute('aria-expanded', 'false');
              if (blocks) blocks.classList.remove('is-open');
            }
          });

          const blockPanels = menuItem.querySelectorAll('[data-mobile-block-panel]');
          const blockToggles = menuItem.querySelectorAll('[data-mobile-block-toggle]');

          if (!currentlyOpen) {
            menuItem.classList.add('is-open');
            toggle.setAttribute('aria-expanded', 'true');
            blockToggles.forEach(function(btn) {
              btn.setAttribute('aria-expanded', 'false');
            });
            blockPanels.forEach(function(panel) {
              panel.classList.add('is-collapsed');
            });
          } else {
            menuItem.classList.remove('is-open');
            toggle.setAttribute('aria-expanded', 'false');
            blockToggles.forEach(function(btn) {
              btn.setAttribute('aria-expanded', 'false');
            });
            blockPanels.forEach(function(panel) {
              panel.classList.add('is-collapsed');
            });
          }
        });
      });

      const blockContentToggles = header.querySelectorAll('[data-mobile-block-toggle]');
      blockContentToggles.forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();

          const containerId = btn.getAttribute('aria-controls');
          if (!containerId) return;

          const container = document.getElementById(containerId);
          if (!container) return;

          const expanded = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
          container.classList.toggle('is-collapsed', expanded);
        });
      });

      // 更新购物车数量
      updateCartCount(header);
      setupAnnouncementRotation(header);

      // 搜索按钮点击事件 - 打开搜索弹窗
      const searchBtn = header.querySelector('[data-search-drawer-trigger]');
      if (searchBtn) {
        searchBtn.addEventListener('click', function(e) {
          e.preventDefault();
          if (typeof window.openSearchDrawer === 'function') {
            window.openSearchDrawer();
          }
        });
      }

      // 购物车按钮点击事件 - 打开购物车弹窗
      const cartBtn = header.querySelector('[data-cart-drawer-trigger]');
      if (cartBtn) {
        cartBtn.addEventListener('click', function(e) {
          e.preventDefault();
          if (typeof window.openCartDrawer === 'function') {
            window.openCartDrawer();
          }
        });
      }

      // Mega dropdown tab switching (hover/focus)
      const megaContainers = header.querySelectorAll('.mt-mega');
      megaContainers.forEach(function(mega) {
        const left = mega.querySelector('.mt-mega__left');
        const right = mega.querySelector('.mt-mega__right');
        if (!left || !right) return;

        updateMegaPanelHeader(mega);

        left.addEventListener('mouseover', onLeftInteract);
        left.addEventListener('focusin', onLeftInteract);

        function onLeftInteract(e) {
          const item = e.target.closest('[data-mega-tab]');
          if (!item) return;
          const tab = item.getAttribute('data-mega-tab');

          // activate left
          left.querySelectorAll('[data-mega-tab]').forEach(function(a){
            a.classList.toggle('is-active', a.getAttribute('data-mega-tab') === tab);
          });

          // activate panel
          right.querySelectorAll('.mt-mega__panel').forEach(function(panel){
            panel.classList.toggle('is-active', panel.getAttribute('data-mega-panel') === tab);
          });

          updateMegaPanelHeader(mega);
        }

        // Prevent body scroll when mega dropdown is open
        const menuItem = mega.closest('.mt-mega-header__menu-item');
        if (menuItem) {
          menuItem.addEventListener('mouseenter', function() {
            // Save current scroll position
            const scrollY = window.scrollY;
            document.body.style.position = 'fixed';
            document.body.style.top = `-${scrollY}px`;
            document.body.style.width = '100%';
            document.body.style.overflow = 'hidden';
          });

          menuItem.addEventListener('mouseleave', function(e) {
            // Check if mouse is leaving to go into mega dropdown
            const relatedTarget = e.relatedTarget;
            if (relatedTarget && mega.contains(relatedTarget)) {
              return; // Mouse is entering mega dropdown, don't restore scroll
            }
            
            // Restore scroll
            const scrollY = document.body.style.top;
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.width = '';
            document.body.style.overflow = '';
            if (scrollY) {
              window.scrollTo(0, parseInt(scrollY || '0') * -1);
            }
          });

          // Also handle mouse leave from mega dropdown itself
          mega.addEventListener('mouseleave', function(e) {
            const relatedTarget = e.relatedTarget;
            if (relatedTarget && menuItem.contains(relatedTarget)) {
              return; // Mouse is going back to menu item, keep scroll locked
            }
            
            // Restore scroll
            const scrollY = document.body.style.top;
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.width = '';
            document.body.style.overflow = '';
            if (scrollY) {
              window.scrollTo(0, parseInt(scrollY || '0') * -1);
            }
          });
        }
      });
    });
  }

  function setupAnnouncementRotation(header) {
    const announcementItems = header.querySelectorAll('.mt-mega-header__announcement-item');
    if (!announcementItems || announcementItems.length <= 1) return;

    let activeIndex = 0;

    announcementItems.forEach(function(item, index) {
      const isActive = index === 0;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });

    setInterval(function() {
      announcementItems[activeIndex].classList.remove('is-active');
      announcementItems[activeIndex].setAttribute('aria-hidden', 'true');

      activeIndex = (activeIndex + 1) % announcementItems.length;

      announcementItems[activeIndex].classList.add('is-active');
      announcementItems[activeIndex].setAttribute('aria-hidden', 'false');
    }, 5000);
  }

  function updateMegaPanelHeader(mega) {
    const activeLeft = mega.querySelector('.mt-mega__left-item.is-active');
    const activePanel = mega.querySelector('.mt-mega__panel.is-active');
    const headerTitle = mega.querySelector('.mt-mega__panel-title');
    const viewAllLink = mega.querySelector('.mt-mega__panel-view-all');
    if (!activeLeft || !activePanel) return;

    const text = activeLeft.textContent || '';
    if (headerTitle) {
      headerTitle.textContent = text.trim();
    }

    if (viewAllLink) {
      const viewAllCard = activePanel.querySelector('.mt-mega__product-card--view-all');
      if (viewAllCard) {
        viewAllLink.href = viewAllCard.getAttribute('href') || '#';
        const title = viewAllCard.querySelector('.mt-mega__product-title');
        if (title) {
          viewAllLink.textContent = title.textContent.trim();
        }
        viewAllLink.style.display = '';
      } else {
        viewAllLink.style.display = 'none';
      }
    }
  }

  // 根据数量直接更新角标 DOM（不发起请求）
  function setCartCount(header, count) {
    const cartCountEl = header.querySelector('[data-cart-count]');
    if (!cartCountEl) return;
    var n = typeof count === 'number' ? count : parseInt(count, 10);
    n = isNaN(n) ? 0 : n;
    cartCountEl.textContent = n > 99 ? '99+' : n;
    cartCountEl.style.display = n > 0 ? 'flex' : 'none';
  }

  // 更新购物车数量（请求 /cart.js）
  function updateCartCount(header) {
    const cartCountEl = header.querySelector('[data-cart-count]');
    if (!cartCountEl) return;

    fetch('/cart.js')
      .then(function(response) {
        if (!response.ok) throw new Error('Failed to fetch cart');
        return response.json();
      })
      .then(function(cart) {
        var rawCount = typeof cart.item_count === 'number' ? cart.item_count : parseInt(cart.item_count, 10);
        var count = isNaN(rawCount) ? 0 : rawCount;
        setCartCount(header, count);
      })
      .catch(function(error) {
        console.error('Error updating cart count:', error);
      });
  }

  // 监听购物车更新：使用主题 pub-sub，加购后无需刷新即可更新角标
  function setupCartUpdateListener() {
    // 主题内加购成功会 publish('cart-update', { cartData: response })，用 subscribe 订阅后直接取 item_count 更新
    if (typeof subscribe === 'function') {
      subscribe('cart-update', function(data) {
        var count = data && data.cartData != null && typeof data.cartData.item_count === 'number'
          ? data.cartData.item_count
          : null;
        var headers = document.querySelectorAll('.mt-mega-header');
        if (count !== null) {
          headers.forEach(function(header) {
            setCartCount(header, count);
          });
        } else {
          headers.forEach(updateCartCount);
        }
      });
    }

    document.addEventListener('cart:updated', function() {
      var headers = document.querySelectorAll('.mt-mega-header');
      headers.forEach(updateCartCount);
    });

    if (typeof window.PUB_SUB_EVENTS !== 'undefined') {
      document.addEventListener(window.PUB_SUB_EVENTS.cartUpdate, function() {
        var headers = document.querySelectorAll('.mt-mega-header');
        headers.forEach(updateCartCount);
      });
    }
  }

  // 页面加载完成后初始化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initMegaHeader();
      setupCartUpdateListener();
    });
  } else {
    initMegaHeader();
    setupCartUpdateListener();
  }

  // 导出更新购物车数量的函数，供其他脚本调用
  window.updateMegaHeaderCartCount = function() {
    const headers = document.querySelectorAll('.mt-mega-header');
    headers.forEach(updateCartCount);
  };

  // 全局监听购物车弹窗打开事件，确保所有购物车按钮都能触发
  document.addEventListener('click', function(e) {
    const cartTrigger = e.target.closest('[data-cart-drawer-trigger]');
    if (cartTrigger && typeof window.openCartDrawer === 'function') {
      e.preventDefault();
      window.openCartDrawer();
    }
  });

  // 全局监听搜索弹窗打开事件，确保所有搜索按钮都能触发
  document.addEventListener('click', function(e) {
    const searchTrigger = e.target.closest('[data-search-drawer-trigger]');
    if (searchTrigger && typeof window.openSearchDrawer === 'function') {
      e.preventDefault();
      window.openSearchDrawer();
    }
  });

})();
